<template>
  <div>
    <div>
      <ChangePasswordForm />
      <EmailNotifications />
    </div>

    <APIKeyIntegration />
    <!-- <SalesforceIntegration /> -->
  </div>
</template>

<script>
import ChangePasswordForm from './ChangePasswordForm'
import EmailNotifications from './EmailNotifications'
import APIKeyIntegration from './APIKeyIntegration'

export default {
  name: 'PaigeSettings',
  components: {
    ChangePasswordForm,
    EmailNotifications,
    APIKeyIntegration
  },
  created() {
    this.$store.dispatch(
      'integration/getIntegrationsListForUser',
      this.$store.state.profile.user.id
    )
    this.$store.dispatch('profile/getProfile', false)
    this.$store.dispatch('profile/getIDPSettings')
  }
}
</script>

<style scoped lang="scss">
@import '@/global.scss';

.grid-row {
  padding-top: 1.25rem;

  height: 100%;
  margin-bottom: 2rem;
}

@media (max-width: 1100px) {
  .grid-row {
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    transition: 1s ease-in;
    grid-row-gap: 1em;
  }
}
</style>
